import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MfDocumentsComponent } from './mf-documents.component';

const routes: Routes = [
  {
    path: '',
    component: MfDocumentsComponent,
    children: [
      {
        path: '**',
        component: MfDocumentsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MfDocumentsRoutingModule {}
